import algoliasearch from 'algoliasearch';

export default {
    data() {
        return {
            dropoffLocations: [],
        };
    },

    watch: {
        pickupLocation(location) {
            if (location === null || location.provider === 'CTR') {
                return this.$store.dispatch('setDropoffLocation', null);
            }

            if (location.dropoff_locations) {
                let locations = location.dropoff_locations.locations.slice(0);

                if (locations.length <= 1 && locations[0] === location.id) {
                    return;
                }

                locations.unshift(location.id);
                algoliasearch(this.searchOptions.appId, this.searchOptions.apiKey)
                    .initIndex(`${this.searchOptions.prefix}locations`)
                    .getObjects(locations.map(e => 'WoS_' + e), (err, content) => {
                        this.$store.dispatch('setDropoffDifferent', true);
                        this.dropoffLocations = content.results;
                    });

                this.$store.dispatch('setDropoffLocation', location);
            }
        },
    },

    methods: {
        updateDropoffLocation(e) {
            this.dropoffLocations.map(locationItem => {
                if (locationItem.id == e.target.value) {
                    this.$store.dispatch('setDropoffLocation', locationItem);
                }
            });
        },
    },
};



// WEBPACK FOOTER //
// ./node_modules/greenmotion-shared/mixins/dropoff.js